// @flow

import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { paymentHeaderFragment } from 'common/fragments/www'

const headerQuery = gql`
query HeaderQuery {
  ${paymentHeaderFragment}
}
`

export default (component: any) => graphql(headerQuery)(component)



// WEBPACK FOOTER //
// ./src/containers/pages/ReservationSelectPaymentPage/graphql.js